import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuthContext } from "contexts/AuthContext"
import useSound from "use-sound"
import { selectMenuItem } from "utils/sounds"
import { SidebarDrawerUI } from "./SidebarDrawer.ui"
import { routes } from "common/navigationRoutes"
import {
  FaUserFriends,
  FaBookOpen,
  FaChartPie,
  FaMedal,
  FaChalkboardTeacher,
  FaComments,
  FaGamepad,
  FaHeadset,
  FaSlidersH,
  FaRegLifeRing,
  FaApple,
  FaGooglePlay,
} from "react-icons/fa"
import HomeIcon from "@mui/icons-material/Home"
import LogoutIcon from "@mui/icons-material/Logout"

const menuItems = [
  { label: "classes", icon: <FaUserFriends />, path: routes.GROUPS },
  { label: "missions", icon: <FaBookOpen />, path: routes.MISSIONS },
  { label: "grades", icon: <FaChartPie />, path: routes.GRADES },
  { label: "rewards", icon: <FaMedal />, path: routes.REWARDS },
  {
    label: "activities_graded_by_teacher",
    icon: <FaChalkboardTeacher />,
    path: routes.TEACHER_GRADES,
  },
  { label: "teacher_messages", icon: <FaComments />, path: routes.TEACHER_MESSAGES },
  { label: "Games", icon: <FaGamepad />, path: routes.NEW_GAMES },
  {
    label: "announcements",
    icon: <HomeIcon />,
    path: routes.ANNOUNCEMENTS,
    badge: 0,
  },
  { label: "" },
  { label: "technical_support", icon: <FaHeadset />, path: routes.TICKETS },
  { label: "Settings", icon: <FaSlidersH />, path: routes.ACCOUNT },
  { label: "Tutorials", icon: <FaRegLifeRing />, path: "" },
  { label: "" },
  {
    label: "App Store",
    icon: <FaApple />,
    path: "",
    externalLink: "https://apps.apple.com/us/app/smash-education/id1381243421",
  },
  {
    label: "Google Play",
    icon: <FaGooglePlay />,
    path: "",
    externalLink:
      "https://play.google.com/store/apps/details?id=com.smasheducation",
  },
  { label: "" },
  { label: "Logout", icon: <LogoutIcon />, path: routes.LOGOUT },
]

export const StudentSidebarView = ({ open = false, onClose = () => { } }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userData, updateUserData, logout, audioSettings } = useAuthContext()
  const [playMenuItem] = useSound(selectMenuItem, { volume: 0.5, html5: true })

  const onMenuItemClick = (path) => {
    if (audioSettings?.enabledAudioEffects) {
      playMenuItem()
    }
    navigate(path)
    onClose()
  }

  const changeTutorialsPreference = (evt) => {
    evt.stopPropagation()
    updateUserData({
      newUserData: {
        allowTutorials: !userData?.allowTutorials,
      },
    })
  }

  const openExternalLink = (url) => {
    if (audioSettings?.enabledAudioEffects) {
      playMenuItem()
    }
    onClose()
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <SidebarDrawerUI
      open={open}
      onClose={onClose}
      menuItems={menuItems}
      userData={userData}
      onMenuItemClick={onMenuItemClick}
      onLogout={() => {
        onClose()
        logout()
      }}
      onChangeTutorialsPreference={changeTutorialsPreference}
      onOpenExternalLink={openExternalLink}
      currentRoute={location.pathname}
    />
  )
}
